import React from 'react';
import PropTypes from 'prop-types';
import RemoveProductButton from '../../RemoveProductButton';
import BasketQuantityWidget from '../BasketQuantityWidget';
import {
  getProductQuantity,
  hasDeleteButton,
  hasQuantityWidget,
} from '../../../utils/Gifts/basket';

import s from './index.module.scss';

const BasketItemControls = ({ product }) => {
  return (
    <div
      className={`${s['basket-item-controls']} ${hasDeleteButton(product.data) && hasQuantityWidget(product.data) ? s['basket-item-controls__inline'] : ''}`}
    >
      {hasQuantityWidget(product.data) && (
        <BasketQuantityWidget quantity={getProductQuantity(product)} productId={product.id} />
      )}
      {hasDeleteButton(product.data) && <RemoveProductButton productId={product.id} />}
    </div>
  );
};

BasketItemControls.propTypes = {
  product: PropTypes.object.isRequired,
};

export default BasketItemControls;
